import api from './axiosConfig';

export const notificationsAPI = {
  getAll: async () => {
    const response = await api.get('/notifications');
    return response.data;
  },

  getUnreadCount: async () => {
    const response = await api.get('/notifications/unread-count');
    return response.data?.count ?? 0;
  },

  markAsRead: async (id) => {
    await api.patch(`/notifications/${id}/read`, {});
  },

  markAllAsRead: async () => {
    await api.patch('/notifications/mark-all-read', {});
  },
};
